module.exports = __webpack_public_path__ + "assets/img/maps.5e50e46c.jpg";